import { render } from "./EditaCuentaEcp.vue?vue&type=template&id=24bbb4ee&scoped=true"
import script from "./EditaCuentaEcp.vue?vue&type=script&lang=js"
export * from "./EditaCuentaEcp.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EditaCuentaEcp.vue?vue&type=style&index=1&id=24bbb4ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bbb4ee"]])

export default __exports__